import {
  isUserActionNeedPhotoVerification,
  isUserNeedKyc,
  isUserNeedOnlyAccountNumbers,
  isUserNeedPartialVerification,
  isUserNeedVerification,
  PhotoVerificationAction,
} from '@atlas/core';

const isActionNeedVerification = (account, operation) =>
  isUserActionNeedPhotoVerification(
    account,
    operation === 'withdrawal'
      ? PhotoVerificationAction.WITHDRAWAL
      : PhotoVerificationAction.DEPOSIT,
  );

export const isPaymentAllowed = (account, operation, autofillProhibited) => {
  return (
    !isUserNeedVerification(account) ||
    (isUserNeedVerification(account) && !isActionNeedVerification(account, operation)) ||
    (isUserNeedOnlyAccountNumbers(account) && autofillProhibited)
  );
};

export const isPartialVerification = (account, operation) =>
  isUserNeedPartialVerification(account) &&
  isUserNeedKyc(account) &&
  isActionNeedVerification(account, operation);
